export default __webpack_public_path__ + "static/media/error-filled.29655a77.svg";